export default __webpack_public_path__ + "static/media/content.4a91d8ab.png";